import * as React from 'react';

import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import {
    AssetWrap,
    ContactLink,
    Description,
    Detail,
    Details,
    Links,
    Section,
    SectionTitle,
    TopRow,
} from './AssetInfoContent.styled';
import { Identity } from './AssetInfoLoading.styled';

const AssetInfoLoading = () => (
    <div aria-hidden="true">
        <TopRow>
            <AssetWrap>
                <Identity>
                    <Bar $width="8rem" $height="8rem" />
                    <SkeletonStack>
                        <Bar $width="18rem" $height="3.6rem" />
                        <Bar $width="16rem" />
                    </SkeletonStack>
                </Identity>
            </AssetWrap>
            <Bar $width="10rem" $height="3.2rem" />
        </TopRow>
        <Description as="div">
            <SkeletonStack>
                <Bar $width="100%" />
                <Bar $width="96%" />
                <Bar $width="84%" />
                <Bar $width="65%" />
            </SkeletonStack>
        </Description>
        <Links>
            {[0, 1, 2, 3].map(i => (
                <ContactLink as="div" key={i}>
                    <Bar $width="12rem" $height="2.8rem" />
                </ContactLink>
            ))}
        </Links>
        <Section>
            <Details>
                {[
                    'Asset Holders:',
                    'First Transaction:',
                    'Current Price:',
                    '24H Change:',
                    'Authorization Flags:',
                    'Supply Status:',
                    'Issuer:',
                    'Contract Address:',
                ].map(label => (
                    <Detail key={label}>
                        <span>{label}</span>
                        <Bar $width="12rem" $height="2.8rem" />
                    </Detail>
                ))}
                <Detail />
            </Details>
        </Section>
        <Section>
            <SectionTitle>Asset Stats on Aquarius</SectionTitle>
            <Details>
                {[0, 1, 2, 3, 4, 5].map(i => (
                    <Detail key={i}>
                        <Bar $width="14rem" />
                        <Bar $width="10rem" $height="2.8rem" />
                    </Detail>
                ))}
            </Details>
        </Section>
    </div>
);

export default AssetInfoLoading;
